export type AumBucketId = 'lt_200m' | 'm200_500m' | 'm500_2b' | 'b2_5b' | 'b5_plus';

export const AUM_FILTER_BUCKETS: {
  id: AumBucketId;
  label: string;
  minMillions: number;
  maxMillions: number | null;
}[] = [
  { id: 'lt_200m', label: 'до 200 млн USD', minMillions: 0, maxMillions: 200 },
  { id: 'm200_500m', label: '200 – 500 млн USD', minMillions: 200, maxMillions: 500 },
  { id: 'm500_2b', label: '0,5 – 2 млрд USD', minMillions: 500, maxMillions: 2000 },
  { id: 'b2_5b', label: '2 – 5 млрд USD', minMillions: 2000, maxMillions: 5000 },
  { id: 'b5_plus', label: '5+ млрд USD', minMillions: 5000, maxMillions: null },
];

export const ALL_AUM_BUCKET_IDS: AumBucketId[] = AUM_FILTER_BUCKETS.map((b) => b.id);

/** AUM в БД может быть в млрд (≤100) или уже в млн — приводим к млн USD */
export function aumToMillionsUsd(aum: number): number {
  return aum <= 100 ? aum * 1000 : aum;
}

export function aumMatchesSelectedBuckets(
  aum: number | null,
  selected: AumBucketId[],
): boolean {
  if (selected.length === 0) return false;
  if (aum === null) return true;
  const millions = aumToMillionsUsd(aum);
  return selected.some((id) => {
    const bucket = AUM_FILTER_BUCKETS.find((b) => b.id === id);
    if (!bucket) return false;
    if (bucket.maxMillions === null) return millions >= bucket.minMillions;
    return millions >= bucket.minMillions && millions < bucket.maxMillions;
  });
}
